import * as types from '../actions/action-types';

const initialState = {
  selectedTooltip: null,
  tooltipData: null,
};

const tooltipReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SHOW_TOOLTIP:
      return {
        ...state,
        selectedTooltip: action.tooltipID,
        tooltipData: action.tooltipData,
      };

    case types.HIDE_TOOLTIP:
      return {
        ...state,
        selectedTooltip: null,
        tooltipData: null,
      };

    default:
      return state;
  }
};

export default tooltipReducer;
